import { AbstractDictionary } from "./AbstractDictionary";
export class DicPositionsOverlappingType extends AbstractDictionary {
  static NAME = "tsadv_DicPositionsOverlappingType";
}
export type DicPositionsOverlappingTypeViewName =
  | "_base"
  | "_local"
  | "_minimal";
export type DicPositionsOverlappingTypeView<
  V extends DicPositionsOverlappingTypeViewName
> = V extends "_base"
  ? Pick<
      DicPositionsOverlappingType,
      | "id"
      | "langValue"
      | "langValue1"
      | "langValue2"
      | "langValue3"
      | "langValue4"
      | "langValue5"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "description1"
      | "description2"
      | "description3"
      | "description4"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_local"
  ? Pick<
      DicPositionsOverlappingType,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_minimal"
  ? Pick<
      DicPositionsOverlappingType,
      | "id"
      | "langValue"
      | "langValue1"
      | "langValue2"
      | "langValue3"
      | "langValue4"
      | "langValue5"
    >
  : never;
